module.exports = __webpack_public_path__ + "img/ic-contact-line_ch.964a7e16.png";